/** Elenco a schede per lo schermo stretto: una card per riga, con caricamento, vuoto e paginazione semplice. */
import { Button, Card, Skeleton } from "antd";
import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Vuoto } from "./ui";

export function ElencoSchede<T>({ righe, chiave, scheda, loading, vuoto, passo = 30 }: { righe: T[]; chiave: (r: T) => string; scheda: (r: T) => ReactNode; loading?: boolean; vuoto: ReactNode; passo?: number }) {
  const { t } = useTranslation();
  const [n, setN] = useState(passo);
  if (loading && !righe.length) return <Skeleton active paragraph={{ rows: 6 }} />;
  if (!righe.length) return <Vuoto titolo={vuoto} />;
  return (
    <div style={{ display: "grid", gap: 10 }}>
      {righe.slice(0, n).map((r) => (
        <Card key={chiave(r)} size="small" styles={{ body: { padding: "10px 12px" } }}>
          {scheda(r)}
        </Card>
      ))}
      {righe.length > n && (
        <Button block onClick={() => setN(n + passo)}>
          {t("comune.altri", { n: righe.length - n })}
        </Button>
      )}
    </div>
  );
}

/** Riga della scheda: etichetta piccola a sinistra, valore a destra. */
export function Coppia({ l, children }: { l: ReactNode; children: ReactNode }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 13, marginTop: 4 }}>
      <span className="muted">{l}</span>
      <span style={{ textAlign: "right", minWidth: 0 }}>{children}</span>
    </div>
  );
}
